/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// True mobile parallax using transform (works on iOS/Android)
(function() {
  const isMobile = window.innerWidth <= 768;
  if (!isMobile) return;
  
  function updateParallax() {
    const elements = document.querySelectorAll('.mobile-parallax-wrapper .parallax-image');
    
    elements.forEach(function(el) {
      const wrapper = el.closest('.mobile-parallax-wrapper');
      if (!wrapper) return;
      
      const rect = wrapper.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Only apply when in viewport
      if (rect.bottom >= 0 && rect.top <= windowHeight) {
        // Calculate parallax offset - reduced intensity to minimize cropping
        const speed = 0.15; // Reduced from 0.25 for less movement
        const yPos = (rect.top - windowHeight / 2) * speed;
        
        el.style.transform = 'translateY(' + yPos + 'px) translateZ(0)';
        el.style.webkitTransform = 'translateY(' + yPos + 'px) translateZ(0)';
      }
    });
  }
  
  // Throttled scroll handler
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        updateParallax();
        ticking = false;
      });
      ticking = true;
    }
  }
  
  // Initialize
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', updateParallax);
  
  // Initial update after delay for lazy load
  setTimeout(updateParallax, 500);
  setTimeout(updateParallax, 1500);
})();
